module.exports = __webpack_public_path__ + "f042ae2292d371c2cf57fb9c6decb246.png";